import apolloClient from './../apolloClient.js'
import createUserPolicies from './../helpers/createUserPolicies'

const state = {
  user: {},
  statuses: [],
  cities: [],
  loadingApp: false,
  errors: null,
  notifications: [],
  notificationsPaginator: {
    total_count: 0,
    page: 1
  }
}

const mutations = {
  SET_USER (state, userObj) {
    state.user = createUserPolicies(userObj)
  },
  UPDATE_AVATAR (state, filePath) {
    state.user.avatar = filePath
  },
  UPDATE_USER (state, userObj) {
    state.user = createUserPolicies(userObj)
  },
  SET_STATUSES (state, statuses) {
    state.statuses = statuses
  },
  SET_CITIES (state, cities) {
    state.cities = cities
  },
  SET_NOTIFICATIONS (state, array) {
    state.notifications = []
    for (let i in array) {
      state.notifications.push(Object.assign({}, array[i]))
    }
  },
  ADD_NOTIFICATIONS (state, array) {
    for (let i in array) {
      state.notifications.push(array[i])
    }
  },
  SET_NOTIFICATIONS_PAGINATOR (state, value) {
    const paginator = {
      totalCount: value.total_count,
      page: value.page
    }
    state.notificationsPaginator = Object.assign({}, paginator)
  },
  ADD_NOTIFICATION_FIRST (state, notification) {
    state.notifications.unshift(notification)
    const totalCount = state.notificationsPaginator.totalCount + 1
    state.notificationsPaginator.totalCount = totalCount
  },
  SET_LOADING_APP (state, value) {
    state.loadingApp = value
  },
  SET_ERROR (state, value) {
    state.errors = value
  }
}

import getNotificationsQuery from './../gql/queries/getNotifications.graphql'
import initAppQuery from './../gql/queries/initApp.graphql'
import updateNotificationQuery from './../gql/queries/updateNotification.graphql'
import markAllNotificationsAsViewedMutation from './../gql/mutations/MarkAllNotificationsAsViewed.graphql'

const actions = {
  initApp: ({commit}) => {
    commit('SET_LOADING_APP', true)
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: initAppQuery,
        fetchPolicy: 'network-only'
      }).then((result) => {
        commit('SET_USER', result.data.user)
        commit('SET_STATUSES', result.data.statuses)
        commit('SET_CITIES', result.data.cities)
        commit('ADD_NOTIFICATIONS', result.data.notifications)
        commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator)
        commit('SET_LOADING_APP', false)
        resolve()
      }).catch((error) => {
        commit('SET_LOADING_APP', false)
        if (error.status < 400 || error.status === 404 || error.status >= 500) {
          commit('SET_ERROR', error)
        }
        reject()
      })
    })
  },
  loadNotifications: ({commit, state}) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getNotificationsQuery,
        variables: {
          page: state.notificationsPaginator.page + 1
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        if (result.data.notifications.length > 0) {
          commit('ADD_NOTIFICATIONS', result.data.notifications)
          commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator)
          resolve()
        } else {
          reject()
        }
      }).catch((error) => {
        console.log(error)
        if (error.status !== 422 || error.status !== 401) {
          commit('SET_ERROR', error)
        }
        reject()
      })
    })
  },
  /**
   * Пометить все уведомления как прочитанные
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  markAllNotificationsAsViewed: ({state, commit}, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: markAllNotificationsAsViewedMutation
      }).then((data) => {
        if (data.data.markAsViewed) {
          let paginator = Object.assign({}, state.notificationsPaginator)
          paginator.total_count = 0
          commit('SET_NOTIFICATIONS_PAGINATOR', paginator)
          let notifications = []
          for (let notice in state.notifications) {
            let notification = Object.assign({}, notice)
            notification.isViewed = true
            notifications.push(notification)
          }
          commit('SET_NOTIFICATIONS', notifications)
          resolve()
        } else {
          reject()
        }
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateNotifications: ({commit}) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: updateNotificationQuery,
        fetchPolicy: 'network-only'
      }).then((result) => {
        console.log(result)
        commit('SET_NOTIFICATIONS', result.data.notifications)
        commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator)
        resolve()
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  }
// clearAuthUser: ({commit}) => {
//   commit('CLEAR_AUTH_USER')
// },
// removeAvatar: ({commit}) => {
//   Vue.http.post(apiDomain + 'api/user/upload-avatar', {}, {headers: getHeader()}).then((response) => {
//     commit('SET_AVATAR', null)
//   })
//
// }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/globalStore.js